module.exports = typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {};